module.exports = __webpack_public_path__ + "static/portfolio-1-afd78648b5e800efa1fea8e9a417cde4.jpg";